document.addEventListener("DOMContentLoaded", function () {
    // Mobile menu toggle
    var mobileMenuToggle = document.querySelector("[data-mobile-menu-toggle]");
    var mobileMenuClose = document.querySelector("[data-mobile-menu-close]");
    var mobileMenu = document.querySelector("[data-mobile-menu]");
    var mobileMenuOverlay = document.querySelector(
        "[data-mobile-menu-overlay]",
    );

    function openMobileMenu() {
        mobileMenu.classList.add("is-open");
        mobileMenuOverlay.classList.add("is-visible");
        document.body.style.overflow = "hidden";
    }

    function closeMobileMenu() {
        mobileMenu.classList.remove("is-open");
        mobileMenuOverlay.classList.remove("is-visible");
        document.body.style.overflow = "";
    }

    if (mobileMenuToggle) {
        mobileMenuToggle.addEventListener("click", openMobileMenu);
    }

    if (mobileMenuClose) {
        mobileMenuClose.addEventListener("click", closeMobileMenu);
    }

    if (mobileMenuOverlay) {
        mobileMenuOverlay.addEventListener("click", closeMobileMenu);
    }

    // Mobile submenu toggle - optimized with cached DOM relationships
    var submenuToggles = document.querySelectorAll("[data-submenu-toggle]");
    var submenuMap = new Map();

    // Cache toggle -> submenu relationships for O(1) lookup
    submenuToggles.forEach(function (toggle) {
        var parentHeader = toggle.closest(
            ".mobile-menu__item-header, .mobile-menu__subitem-header",
        );
        var submenu = parentHeader ? parentHeader.nextElementSibling : null;
        if (submenu && submenu.hasAttribute("data-submenu")) {
            submenuMap.set(toggle, submenu);
        }
    });

    // Add click handlers using cached relationships
    submenuToggles.forEach(function (toggle) {
        toggle.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();

            var expanded = this.getAttribute("aria-expanded") === "true";
            this.setAttribute("aria-expanded", !expanded);

            var submenu = submenuMap.get(this);
            if (submenu) {
                submenu.classList.toggle("is-open");
            }
        });
    });

    // Search bar toggle
    var searchToggle = document.querySelector("[data-search-toggle]");
    var searchBar = document.querySelector("[data-search-bar]");
    var searchClose = document.querySelector("[data-search-close]");
    var headerSearchInput = document.querySelector(
        "[data-header-search-input]",
    );

    function openSearch() {
        if (searchBar) {
            searchBar.classList.add("is-open");
            searchBar.setAttribute("aria-hidden", "false");
            if (headerSearchInput) {
                setTimeout(function () {
                    headerSearchInput.focus();
                }, 100);
            }
        }
    }

    function closeSearch() {
        if (searchBar) {
            searchBar.classList.remove("is-open");
            searchBar.setAttribute("aria-hidden", "true");
            closeHeaderPredictiveSearch();
        }
    }

    if (searchToggle) {
        searchToggle.addEventListener("click", openSearch);
    }

    if (searchClose) {
        searchClose.addEventListener("click", closeSearch);
    }

    document.addEventListener("keydown", function (e) {
        if (
            e.key === "Escape" &&
            searchBar &&
            searchBar.classList.contains("is-open")
        ) {
            closeSearch();
        }
    });

    // Header Predictive Search
    var headerPredictiveContainer = document.querySelector(
        "[data-header-predictive-search]",
    );
    var headerPredictiveResults = document.querySelector(
        "[data-header-predictive-results]",
    );
    var headerPredictiveLoading = document.querySelector(
        "[data-header-predictive-loading]",
    );

    var headerSearchTimeout = null;
    var headerAbortController = null;

    if (headerSearchInput && headerPredictiveContainer) {
        headerSearchInput.addEventListener("input", function () {
            var query = this.value.trim();

            if (headerSearchTimeout) clearTimeout(headerSearchTimeout);
            if (headerAbortController) headerAbortController.abort();

            if (query.length < 2) {
                closeHeaderPredictiveSearch();
                return;
            }

            headerSearchTimeout = setTimeout(function () {
                performHeaderPredictiveSearch(query);
            }, 300);
        });

        document.addEventListener("click", function (e) {
            if (
                headerPredictiveContainer &&
                !headerPredictiveContainer.contains(e.target) &&
                e.target !== headerSearchInput &&
                !searchBar.contains(e.target)
            ) {
                closeHeaderPredictiveSearch();
            }
        });
    }

    function performHeaderPredictiveSearch(query) {
        headerAbortController = new AbortController();

        headerPredictiveContainer.classList.add("is-active");
        headerPredictiveLoading.style.display = "block";
        headerPredictiveResults.innerHTML = "";

        var searchUrl =
            "/search/suggest.json?q=" +
            encodeURIComponent(query) +
            "&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[fields]=id,title,image,price,compare_at_price,variants,url,available";

        fetch(searchUrl, { signal: headerAbortController.signal })
            .then(function (response) {
                return response.json();
            })
            .then(function (data) {
                headerPredictiveLoading.style.display = "none";
                renderHeaderPredictiveResults(data, query);
            })
            .catch(function (error) {
                if (error.name !== "AbortError") {
                    console.error("Header predictive search error:", error);
                    headerPredictiveLoading.style.display = "none";
                }
            });
    }

    function renderHeaderPredictiveResults(data, query) {
        var products =
            (data.resources &&
                data.resources.results &&
                data.resources.results.products) ||
            [];

        // Clear previous results
        headerPredictiveResults.textContent = "";

        if (products.length === 0) {
            var noResults = document.createElement("div");
            noResults.className = "header__predictive-no-results";
            var noResultsText = document.createElement("p");
            noResultsText.textContent = 'No products found for "' + query + '"';
            noResults.appendChild(noResultsText);
            headerPredictiveResults.appendChild(noResults);
            return;
        }

        var container = document.createElement("div");
        container.className = "header__predictive-products";

        var heading = document.createElement("h4");
        heading.className = "header__predictive-heading";
        heading.textContent = "PRODUCTS";
        container.appendChild(heading);

        var grid = document.createElement("div");
        grid.className = "header__predictive-grid";

        products.forEach(function (product) {
            var imageUrl = product.image
                ? product.image.replace(/(\.[^.]+)$/, "_300x300$1")
                : "";
            var price = product.price ? formatHeaderMoney(product.price) : "";
            var hasDiscount =
                product.compare_at_price &&
                product.compare_at_price > product.price;
            var comparePrice = hasDiscount
                ? formatHeaderMoney(product.compare_at_price)
                : "";
            var discountPercent = hasDiscount
                ? Math.round(
                      ((product.compare_at_price - product.price) /
                          product.compare_at_price) *
                          100,
                  )
                : 0;

            var card = document.createElement("div");
            card.className = "header__predictive-card";

            // Image link
            var imageLink = document.createElement("a");
            imageLink.href = product.url;
            imageLink.className = "header__predictive-card-image";

            if (imageUrl) {
                var img = document.createElement("img");
                img.src = imageUrl;
                img.alt = product.title;
                img.loading = "lazy";
                imageLink.appendChild(img);
            } else {
                var placeholder = document.createElement("div");
                placeholder.className = "header__predictive-card-placeholder";
                imageLink.appendChild(placeholder);
            }
            card.appendChild(imageLink);

            // Content container
            var content = document.createElement("div");
            content.className = "header__predictive-card-content";

            // Title link
            var titleLink = document.createElement("a");
            titleLink.href = product.url;
            titleLink.className = "header__predictive-card-title";
            titleLink.textContent = product.title;
            content.appendChild(titleLink);

            // Price container
            var priceContainer = document.createElement("div");
            priceContainer.className = "header__predictive-card-price";

            if (price) {
                var currentPrice = document.createElement("span");
                currentPrice.className = "header__predictive-card-price-current";
                currentPrice.textContent = price;
                priceContainer.appendChild(currentPrice);
            }

            if (comparePrice) {
                var priceLabel = document.createElement("span");
                priceLabel.className = "header__predictive-card-price-label";
                priceLabel.textContent = "MRP";
                priceContainer.appendChild(priceLabel);

                var comparePriceEl = document.createElement("span");
                comparePriceEl.className = "header__predictive-card-price-compare";
                comparePriceEl.textContent = comparePrice;
                priceContainer.appendChild(comparePriceEl);
            }

            if (discountPercent) {
                var discount = document.createElement("span");
                discount.className = "header__predictive-card-discount";
                discount.textContent = discountPercent + "% OFF";
                priceContainer.appendChild(discount);
            }

            content.appendChild(priceContainer);
            card.appendChild(content);
            grid.appendChild(card);
        });

        container.appendChild(grid);

        // View all link
        var viewAllLink = document.createElement("a");
        viewAllLink.href =
            "/search?q=" +
            encodeURIComponent(query) +
            "&type=product&options[prefix]=last";
        viewAllLink.className = "header__predictive-view-all";
        viewAllLink.textContent = "View all results";
        container.appendChild(viewAllLink);

        headerPredictiveResults.appendChild(container);
    }

    function closeHeaderPredictiveSearch() {
        if (headerPredictiveContainer) {
            headerPredictiveContainer.classList.remove("is-active");
            if (headerPredictiveResults) headerPredictiveResults.innerHTML = "";
            if (headerPredictiveLoading)
                headerPredictiveLoading.style.display = "none";
        }
    }

    function formatHeaderMoney(cents) {
        var amount = Math.round(cents).toLocaleString('en-IN');
        var symbol = window.headerCurrencySymbol || "₹";
        return symbol + amount;
    }

    // Prevent navigation on # links (non-clickable parent items)
    document
        .querySelectorAll(
            '.header__menu-link[href="#"], .mobile-menu__link[href="#"]',
        )
        .forEach(function (link) {
            link.addEventListener("click", function (e) {
                e.preventDefault();
                // On mobile, toggle the submenu if it exists
                var submenuToggle = this.parentElement.querySelector(
                    "[data-submenu-toggle]",
                );
                if (submenuToggle && window.innerWidth < 1024) {
                    submenuToggle.click();
                }
            });
        });
});
